<template>
  <div class="bindRole addCommon" style="height: 100%">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{ titleType }}</span>
    </div>
    <div class="content">
      <div class="operation">
        <div class="operationBtn">
          <el-button @click="delTagRole()" :disabled="delDisabled">{{$t('LanguageLib.DELETE')}}</el-button>
          <el-button type="primary" @click="addBindRole">{{$t('LanguageLib.ADD_TO')}}</el-button>
        </div>
        <div class="operationSearch">
          <el-input
            placeholder=""
            prefix-icon="el-icon-search"
            v-model="tagRolesearchText"
            @keyup.enter.native="searchTagList"
          >
          </el-input>
        </div>
      </div>
      <div class="tableWarp">
        <div class="tableParent">
          <el-table
            :data="tableDataTagRole"
            empty-text=" "
            stripe
            @selection-change="selectionChange"
            @sort-change='sortChangeTagRole'
            ref="listPowerSupplyTab"
            style="width: auto;"
            v-loading="loading"
            height="100%">
            <el-table-column
              type="selection"
              width="45">
            </el-table-column>
            <el-table-column
              prop="roleName"
              :label="$t('LanguageLib.ROLE_NAME')"
              sortable="custom"
              min-width="100">
              <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start" >
                  <span slot="content" type="roleName">{{scope.row.roleName}}</span>
                  <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;   vertical-align: middle;" type="roleName">{{scope.row.roleName}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="domainTypeName"
              :label="$t('LanguageLib.ORGANIZATION_TYPE')"
              sortable="custom"
              min-width="100">
              <template slot-scope="scope">
                <el-tooltip effect="light" placement="top-start">
                  <span slot="content" type="domainTypeName">{{scope.row.domainTypeName}}</span>
                  <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;   vertical-align: middle;" type="domainTypeName">{{scope.row.domainTypeName}}</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column
              prop="rank"
              :label="$t('LanguageLib.USER_TYPE')"
              sortable="custom"
              min-width="250">
              <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start">
                <span slot="content" type="rank">{{$commonfun.getUserTypeName(scope.row.rank)}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="rank">{{$commonfun.getUserTypeName(scope.row.rank)}}</span>
              </el-tooltip>
            </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          @size-change="handleSizeChangeTagRole"
          @current-change="handleCurrentChangeTagRole"
          :current-page="tagRolecurrentPage"
          :page-sizes="[20, 50, 100]"
          :page-size="tagRolepageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageTotalTagRole">
        </el-pagination>
      </div>
      <el-dialog :title="$t('LanguageLib.ADD_ROLE')" :visible.sync="dialogAddRole" class="addBindRoleDialog dialogList" :before-close="closeDialog" :close-on-click-modal="false">
        <div class="operationSearch">
          <span style="line-height: 30px;padding-left: 18px;">{{$t('LanguageLib.SELECTED_ROLES')}}：{{selectUserTagDataAdd.length}}</span>
          <el-input
            placeholder=""
            prefix-icon="el-icon-search"
            v-model="addTagRolesearchText"
            @keyup.enter.native="searchAddTagList"
          >
          </el-input>
        </div>
        <div class="tableParent">
        <el-table
          ref="tableList"
          empty-text=" "
          class="table-fixed"
          :data="tableDataAddRole"
          stripe
          @selection-change="selectionChangeAddTagRole"
          @sort-change='sortChangeAddTagRole'
          style="width: auto;"
          v-loading="loading"
          height="100%">
          <el-table-column
            type="selection"
            width="45">
          </el-table-column>
          <el-table-column
            prop="roleName"
            :label="$t('LanguageLib.ROLE_NAME')"
            sortable="custom"
            min-width="100">
            <template slot-scope="scope" class="code">
              <el-tooltip class="code" effect="light" placement="top-start" >
                <span slot="content" type="roleName">{{scope.row.roleName}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="roleName">{{scope.row.roleName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="domainTypeName"
            :label="$t('LanguageLib.ORGANIZATION_TYPE')"
            sortable="custom"
            min-width="100">
            <template slot-scope="scope" class="code">
              <el-tooltip effect="light" placement="top-start" class="code">
                <span slot="content" type="domainTypeName">{{scope.row.domainTypeName}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="domainTypeName">{{scope.row.domainTypeName}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            prop="rank"
            :label="$t('LanguageLib.USER_TYPE')"
            sortable="custom"
            min-width="250">
            <template slot-scope="scope">
              <el-tooltip effect="light" placement="top-start" >
                <span slot="content" type="rank">{{$commonfun.getUserTypeName(scope.row.rank)}}</span>
                <span ref="toolTipItem" style="max-height: 55px;display: inline-block;display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;    vertical-align: middle;" type="rank">{{$commonfun.getUserTypeName(scope.row.rank)}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="handleSizeChangAddTagRole"
        @current-change="handleCurrentChangeAddTagRole"
        :current-page="addTagRolecurrentPage"
        :page-sizes="[20, 50, 100]"
        :page-size="addTagRolepageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotalAddRole">
      </el-pagination>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submit()" :loading="loadingSave">{{$t('LanguageLib.DETERMINE')}}</el-button>
        </div>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import basicdataApi from '../../api/basicdata'
export default {
  name: 'AddStore',
  props: ['currentPage', 'pageSize', 'parentId', 'searchText', 'sort', 'sortOrder', 'checkedStoreTypeData', 'checkedModeOperationData', 'checkedBrandData', 'orgName', 'type', 'sortNumber', 'orgTypeid', 'remark'],
  data () {
    return {
      loading: true, // loading状态
      titleType: this.$t('LanguageLib.BIND_ROLE'),
      delDisabled: true, // 删除按钮默认禁用
      selectUserTagData: [], // 选中的组织数据
      selectUserTagDataAdd: [], // 选中的要添加的组织数据
      dialogAddRole: false, // 是否显示添加角色弹框
      tableDataTagRole: [], // 列表数据-角色列表
      pageTotalTagRole: 0, // 数据总数-角色列表
      tableDataAddRole: [], // 列表数据-添加角色
      pageTotalAddRole: 0, // 数据总数-添加角色
      prevSort: 'ascending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp: 'roleName', // 记录前一次的prop值
      prevSort1: 'ascending', // 记录前一次的排序状态（elementUI默认有三种，即descending，ascending和null）
      prevProp1: 'roleName', // 记录前一次的prop值
      getTagRoleList: (pageIndex, pageSize, sort, IsAsc, UserTagId, SearchVal) => {
        this.loading = true
        // 请求列表接口数据
        basicdataApi.tagRoleList('post', '/Tag/tagRoleList', { pageIndex, pageSize, sort, IsAsc, UserTagId, SearchVal })
          .then(res => {
            this.tableDataTagRole = res.data.data
            this.pageTotalTagRole = res.data.total
            this.loading = false
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }, // 请求数据列表的函数角色列表
      getAddTagRoleList: (pageIndex, pageSize, sort, IsAsc, UserTagId, SearchVal) => {
        this.loading = true
        // 请求列表接口数据
        basicdataApi.addTagRoleList('post', '/Tag/roleList', { pageIndex, pageSize, sort, IsAsc, UserTagId, SearchVal })
          .then(res => {
            this.tableDataAddRole = res.data.data
            this.pageTotalAddRole = res.data.total
            this.loading = false
          })
          .catch(err => {
            this.$commonfun.console.log(err)
          })
      }, // 请求数据列表的函数-添加角色
      tagRolecurrentPage: 1, // 默认显示第1页数据-角色列表
      tagRolepageSize: 20, // 默认每页显示20条数据-角色列表
      tagRolesort: 0, // 排序字段 0：添加时间 1：角色名称 2：组织类型 3：用户类型 -角色列表
      tagRoleIsAsc: true, // 排序方式逆序：desc正序asc -角色列表
      tagRolesearchText: '', // 模糊搜索 -角色列表
      id: this.$route.query.id, // 人员标签id
      addTagRolecurrentPage: 1, // 默认显示第1页数据-添加角色
      addTagRolepageSize: 20, // 默认每页显示20条数据-添加角色
      addTagRolesort: 0, // 排序字段 0：添加时间 1：角色名称 2：组织类型 3：用户类型 -添加角色
      addTagRoleIsAsc: true, // 排序方式逆序：desc正序asc -添加角色
      addTagRolesearchText: '', // 模糊搜索 -添加角色
      loadingSave: false // 保存按钮加loding
    }
  },
  created () {
    this.getTagRoleList(this.tagRolecurrentPage, this.tagRolepageSize, this.tagRolesort, this.tagRoleIsAsc, this.id, this.tagRolesearchText)
  },
  methods: {
    // 返回
    goReturn () {
      this.$router.push('/basicdata/tagmanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&isAsc=' + this.$route.query.isAsc + '&currentType=' + this.$route.query.currentType)
    },
    // 列表排序-角色列表
    sortChangeTagRole (column) {
      if (column.order !== null) {
        this.prevSort = column.order
        if (column.order === 'ascending') {
          this.tagRoleIsAsc = true
          this.prevSort = 'ascending'
        } else if (column.order === 'descending') {
          this.tagRoleIsAsc = false
          this.prevSort = 'descending'
        }
        if (this.prevProp !== column.prop) {
          var columns = this.$refs.listPowerSupplyTab.columns.find(item => item.property === this.prevProp)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort === 'descending' ? 'ascending' : 'descending'
        this.prevProp = column.prop
        this.prevSort = column.column.order
        this.tagRoleIsAsc = column.column.order !== 'descending'
      }
      switch (column.prop) {
        case 'roleName':
          this.tagRolesort = 1
          break
        case 'domainTypeName':
          this.tagRolesort = 2
          break
        case 'rank':
          this.tagRolesort = 3
          break
      }
      // 请求列表接口数据
      this.getTagRoleList(this.tagRolecurrentPage, this.tagRolepageSize, this.tagRolesort, this.tagRoleIsAsc, this.id, this.tagRolesearchText)
    },
    // 页数改变-角色列表
    handleSizeChangeTagRole (val) {
      this.tagRolepageSize = val
      // 请求列表接口数据
      this.getTagRoleList(this.tagRolecurrentPage, this.tagRolepageSize, this.tagRolesort, this.tagRoleIsAsc, this.id, this.tagRolesearchText)
    },
    // 每页条数改变-角色列表
    handleCurrentChangeTagRole (val) {
      this.tagRolecurrentPage = val
      // 请求列表接口数据
      this.getTagRoleList(this.tagRolecurrentPage, this.tagRolepageSize, this.tagRolesort, this.tagRoleIsAsc, this.id, this.tagRolesearchText)
    },
    // 列表模糊搜索-角色列表
    searchTagList () {
      this.tagRolecurrentPage = 1
      this.getTagRoleList(this.tagRolecurrentPage, this.tagRolepageSize, this.tagRolesort, this.tagRoleIsAsc, this.id, this.tagRolesearchText)
    },
    // 添加绑定角色数据
    addBindRole () {
      this.dialogAddRole = true
      this.addTagRolecurrentPage = 1
      this.addTagRolepageSize = 20
      this.addTagRolesort = 0
      this.addTagRoleIsAsc = true
      this.addTagRolesearchText = ''
      this.selectUserTagDataAdd = []
      this.$nextTick(() => {
        this.$refs.tableList.clearSort()
      })
      this.getAddTagRoleList(this.addTagRolecurrentPage, this.addTagRolepageSize, this.addTagRolesort, this.addTagRoleIsAsc, this.id, this.addTagRolesearchText)
    },
    // 列表排序 -添加角色
    sortChangeAddTagRole (column) {
      if (column.order !== null) {
        this.prevSort1 = column.order
        if (column.order === 'ascending') {
          this.addTagRoleIsAsc = true
          this.prevSort1 = 'ascending'
        } else if (column.order === 'descending') {
          this.addTagRoleIsAsc = false
          this.prevSort1 = 'descending'
        }
        if (this.prevProp1 !== column.prop) {
          var columns = this.$refs.tableList.columns.find(item => item.property === this.prevProp1)
          columns.order = ''
        }
      }
      if (column.order === null) {
        column.column.order = this.prevSort1 === 'descending' ? 'ascending' : 'descending'
        column.order = this.prevSort1 === 'descending' ? 'ascending' : 'descending'
        this.prevProp1 = column.prop
        this.prevSort1 = column.column.order
        this.addTagRoleIsAsc = column.column.order !== 'descending'
      }
      switch (column.prop) {
        case 'roleName':
          this.addTagRolesort = 1
          break
        case 'domainTypeName':
          this.addTagRolesort = 2
          break
        case 'rank':
          this.addTagRolesort = 3
          break
      }
      // 请求列表接口数据
      this.getAddTagRoleList(this.addTagRolecurrentPage, this.addTagRolepageSize, this.addTagRolesort, this.addTagRoleIsAsc, this.id, this.addTagRolesearchText)
    },
    // 页数改变 -添加角色
    handleSizeChangAddTagRole (val) {
      this.addTagRolepageSize = val
      // 请求列表接口数据
      this.getAddTagRoleList(this.addTagRolecurrentPage, this.addTagRolepageSize, this.addTagRolesort, this.addTagRoleIsAsc, this.id, this.addTagRolesearchText)
    },
    // 每页条数改变 -添加角色
    handleCurrentChangeAddTagRole (val) {
      this.addTagRolecurrentPage = val
      // 请求列表接口数据
      this.getAddTagRoleList(this.addTagRolecurrentPage, this.addTagRolepageSize, this.addTagRolesort, this.addTagRoleIsAsc, this.id, this.addTagRolesearchText)
    },
    // 列表模糊搜索 -添加角色
    searchAddTagList () {
      this.addTagRolecurrentPage = 1
      this.getAddTagRoleList(this.addTagRolecurrentPage, this.addTagRolepageSize, this.addTagRolesort, this.addTagRoleIsAsc, this.id, this.addTagRolesearchText)
    },
    // 选择要添加的角色
    selectionChangeAddTagRole (selection) {
      this.selectUserTagDataAdd = []
      for (let i = 0; i < selection.length; i++) {
        this.selectUserTagDataAdd.push(selection[i].id)
      }
    },
    // 关闭对话框  清除校验
    closeDialog () {
      this.dialogAddRole = false
    },
    // 添加角色
    submit () {
      if (this.selectUserTagDataAdd.length === 0) {
        this.dialogAddRole = false
      } else {
        this.loadingSave = true
        basicdataApi.Createbindroles('post', '/Tag/bindroles', {
          UserTagId: this.$route.query.id,
          RoleIds: this.selectUserTagDataAdd
        })
          .then(res => {
            this.$message({
              type: 'success',
              message: this.$t('LanguageLib.ADDED_SUCCESSFULLY1')
            })
            this.dialogAddRole = false
            this.getTagRoleList(this.tagRolecurrentPage, this.tagRolepageSize, this.tagRolesort, this.tagRoleIsAsc, this.id, this.tagRolesearchText)
            this.loadingSave = false
          })
          .catch(err => {
            this.loadingSave = false
            this.$commonfun.console.log(err)
          })
      }
    },
    // 删除绑定角色数据
    delTagRole () {
      this.$commonfun.confirm(this.$t('LanguageLib.ARE_YOU_SURE_YOU_WANT_TO_DELETE_IT1'), this.$t('LanguageLib.DELETE'), this.$t('LanguageLib.DETERMINE'), this.$t('LanguageLib.CANCEL'), false, 'warning', this)
        .then(() => {
          basicdataApi.delTagRole('post', '/Tag/delTagRole', this.selectUserTagData)
            .then(res => {
              this.getTagRoleList(this.tagRolecurrentPage, this.tagRolepageSize, this.tagRolesort, this.tagRoleIsAsc, this.id, this.tagRolesearchText)
              this.$message({
                type: 'success',
                message: this.$t('LanguageLib.SUCCESSFULLY_DELETED')
              })
            })
            .catch(err => {
              this.$commonfun.console.log(err)
            })
        }).catch(() => {
          this.$message({
            type: 'success',
            message: this.$t('LanguageLib.DeletionCancelled')
          })
        })
    },
    // 选择要删除的角色
    selectionChange (selection) {
      this.selectUserTagData = []
      for (let i = 0; i < selection.length; i++) {
        this.selectUserTagData.push(selection[i].id)
      }
      if (this.selectUserTagData.length === 0) {
        this.delDisabled = true
      } else {
        this.delDisabled = false
      }
    }
  }
}
</script>

<style lang="scss">
  .bindRole {
    .TeInput input {
      border-right: 0px;
      border-radius: 4px 0 0 4px;
    }
    .return {
      padding-left: 25px;
      position: relative;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      line-height: 50px;
      border-bottom: 1px solid #F2F2F2;
      .el-icon-back {
        margin-right: 15px;
        cursor: pointer;
      }
      .border {
        position: absolute;
        height: 37px;
        border-left: 1px solid #f1f1f1;
        display: inline-block;
        top: 5px;
      }
      .title {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        margin-left: 15px;
      }
    }
    .content::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }
    .content::-webkit-scrollbar-thumb {
      border-radius: 5px;
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      background: #E1E1E1;
    }
    .content::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
      border-radius: 5px;
      background: #fff;
    }
    .content {
      background: rgba(255, 255, 255, 1);
      width: 100%;
      height: calc( 100% - 66px);
      overflow-y: auto;
      padding: 0 100px 20px 100px;
      padding-top: 15px;
      box-sizing: border-box;
      .operation{
        background: #fff;
        padding: 0;
        overflow: hidden;
        .operationBtn{
          width: auto;
          display: inline-block;
          float:left;
          position: relative;
          .el-button{
            height: 30px;
            padding: 7px 20px;
          }
        }
        .operationSearch{
          float:right;
          position: relative;
          .el-input{
            width: 160px;
            .el-input__inner{
              height: 30px;
              line-height: 30px;
              border-radius: 20px;
            }
          }
          .el-icon-search{
            line-height: 30px;
          }
        }
      }
      .tableWarp{
        height: calc(100% - 45px);
        border: 1px solid #E1E1E1;
      }
      .tableParent{
        height: calc( 100% - 48px );
      }
      .el-pagination{
        padding: 8px 15px 5px;
        height: 35px;
        background: #fff;
      }
      .el-button--primary{
        background-color:#3BC6B9;
        color:#fff;
        border:none;
        margin-left: 10px;
      }
      .el-button--primary:hover{
        background-color:#3BC6B9;
        color:#fff;
        border:none;
      }
      /*.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background-color: #3BC6B9 !important;
        border-color: #3BC6B9 !important;
      }*/
      // 更改表格的滚动条样式
      .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
      .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
          width: 10px;
          height: 10px;
      }
      .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-thumb,
      .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-thumb {
        border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
        background: #E1E1E1;
      }
      .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar-track,
      .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar-track {
        border-radius: 5px;
        background: #fff;
      }
      .colorG{
        height:20px;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(59,198,185,1);
        line-height:20px;
      }
      .el-table .descending .sort-caret.descending{
        border-top-color: #3BC6B9;
      }
      .el-table .ascending .sort-caret.ascending{
        border-bottom-color: #3BC6B9;
      }
      .el-pager li.active{
        color: #3BC6B9;
      }
      .el-table__fixed-body-wrapper .el-table__body{
          padding-bottom: 10px;
      }
      .el-table-column--selection{
        text-align: center !important;
      }
      .el-tooltip__popper.is-dark{
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        border: 1px solid #E4E7ED !important;
        background-color: #fff;
        color: #000;
        .popper__arrow{
          border-top-color: #E4E7ED;
        }
        .popper__arrow::after{
          border-top-color: #fff;
        }
      }
      // 上传附件样式
      .upLoadAttachmentDialog {
        .el-dialog__body{
          padding-top: 0;
        }
        .el-form-item__label{
          float: none;
        }
        .el-select{
          width: 100%;
        }
        .el-button--primary{
          margin-left: 0;
        }
        .dialog-footer{
          .el-button{
            padding: 8px 14px;
          }
        }
        .el-upload-list{
          border: none;
        }
        .el-upload-list__item{
          border: none;
        }
      }
      .el-table__fixed-right{
        height: 100% !important;
      }
    }
     /*修改按钮样式*/
    .el-button--primary {
      background-color: #3BC6B9;
      border-color: #3BC6B9;
      height: 30px;
      padding: 7px 20px;
      margin-bottom: 15px;
    }
    .colorRed {
      color: red;
    }
    .el-table__header{
      width: calc(100% + 17px) !important;
    }
    .el-table__body{
      width: calc(100% + 7px) !important;
    }
  }
  .uploadParent{
    .el-button--primary{
      margin-bottom: 0;
    }
    .el-upload__tip{
      margin-top: 10px;
    }
  }
.addBindRoleDialog{
  .el-dialog{
    height: calc(100% - 170px);
    width: 1000px !important;
    .el-dialog__body{
      padding-top: 0;
      padding-bottom: 0;
      height: calc(100% - 130px);
      .operationSearch{
        overflow: hidden;
        margin-bottom: 10px;
        .el-input{
          width: 160px;
          float: right;
          .el-input__inner{
            height: 30px;
            line-height: 30px;
            border-radius: 20px;
          }
        }
        .el-icon-search{
          line-height: 30px;
        }
      }
      .tableParent{
        height: calc(100% - 77px);
        border: 1px solid #EBEEF5;
        border-bottom: 0;
      }
    }
    .el-dialog__footer{
      padding: 25px 20px 20px;
    }
  }
  .el-pagination{
    padding: 8px 15px 5px;
    height: 35px;
    background: #fff;
    border: 1px solid #EBEEF5;
    border-top: none;
  }
}
</style>
